<template>
  <div class="empty-state-container">
    <div class="empty-state-content">
      <v-icon :color="iconColor" size="120">{{ icon }}</v-icon>
      <h2 class="empty-state-title">{{ title }}</h2>
      <p class="empty-state-subtitle">{{ subtitle }}</p>
      <div class="empty-state-actions">
        <v-btn
          @click="$emit('show-all')"
          color="#fddf00"
          variant="flat"
          size="large"
          :prepend-icon="actionIcon"
        >
          {{ actionText }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmptyState",
  props: {
    type: {
      type: String,
      required: true,
      validator: (value) => ["no-orders", "no-pinned"].includes(value),
    },
  },
  computed: {
    config() {
      const configs = {
        "no-orders": {
          icon: "mdi-package-variant-closed",
          iconColor: "#fddf00",
          title: "No Orders Found",
          subtitle: "Currently, there are no provinces with active orders.",
          actionText: "Show All Provinces",
          actionIcon: "mdi-eye",
        },
        "no-pinned": {
          icon: "mdi-pin-off-outline",
          iconColor: "#fddf00",
          title: "No Pinned Provinces",
          subtitle:
            "You haven't pinned any provinces for monitoring yet. Pin your favorite provinces for quick access.",
          actionText: "Show All Provinces",
          actionIcon: "mdi-eye",
        },
      };
      return configs[this.type];
    },
    icon() {
      return this.config.icon;
    },
    iconColor() {
      return this.config.iconColor;
    },
    title() {
      return this.config.title;
    },
    subtitle() {
      return this.config.subtitle;
    },
    actionText() {
      return this.config.actionText;
    },
    actionIcon() {
      return this.config.actionIcon;
    },
  },
  emits: ["show-all"],
};
</script>

<style scoped>
.empty-state-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: 2rem;
}

.empty-state-content {
  text-align: center;
  max-width: 500px;
  padding: 3rem 2rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(253, 223, 0, 0.2);
}

.empty-state-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 1.5rem 0 1rem;
}

.empty-state-subtitle {
  font-size: 1.1rem;
  color: #7f8c8d;
  margin-bottom: 2rem;
  line-height: 1.6;
}

.empty-state-actions {
  display: flex;
  justify-content: center;
}

@media (max-width: 768px) {
  .empty-state-container {
    padding: 1rem;
    min-height: 300px;
  }

  .empty-state-content {
    padding: 2rem 1.5rem;
    border-radius: 16px;
  }

  .empty-state-title {
    font-size: 1.5rem;
  }

  .empty-state-subtitle {
    font-size: 1rem;
  }

  .empty-state-actions .v-btn {
    width: 100%;
    max-width: 250px;
  }
}
</style>
